<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->
<div mat-dialog-content>
  <mat-form-field class="json-editor">
    <mat-label>Survey JSON</mat-label>
    <textarea matInput [(ngModel)]="json" rows="35" tabindex="-1"></textarea>
  </mat-form-field>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="onSave()">Save</button>
  </div>
</div>